const ACCESS_ANONYMOUS = -1;
const ACCESS_FREE = 0;
const ACCESS_XL = 1;
const ACCESS_XXL = 2;
const ACCESS_GM = 3;
const ACCESS_TGM = 4;
const ACCESS_ADMIN = 5;
const ACCESS_OWNER = 6;

export class BobTVUser {
    /**
     * @param {HitagiChatUser|object} user
     */
    constructor(user) {
        return Object.assign(this, {_loaded: false}, user);
    }

    isLoggedIn() {
        return typeof this.nick !== 'undefined' && this.active === 1;
    }

    exists() {
        return userExists(this);
    }

    isAnonymous() {
        return isAnonymous(this);
    };

    isActive() {
        return isActive(this);
    }

    isXXL() {
        return isXXL(this);
    }

    isAdmin() {
        return isAdmin(this);
    }

    isOwner() {
        return isOwner(this);
    }

    isCertified() {
        return isCertified(this);
    }

    /**
     * @param {HitagiChatUser|BobTVUser} user
     * @return {boolean}
     */
    isUserBlocked(user) {
        for (var index in this.blocklist) {
            if (this.blocklist[index] === user.uid) {
                return true;
            }
        }

        return false;
    }

    /**
     * @param {HitagiChatUser|BobTVUser|{uid}} user
     * @return {BlocklistEntry|boolean}
     */
    isBeingBlocked(user) {
        if (this.hasOwnProperty('blocked_by_extended')) {
            for (let index in this.blocked_by_extended) {
                if (this.blocked_by_extended[index].uid === user.uid) return this.blocked_by_extended[index];
            }

            return false;
        }

        let _user = user instanceof BobTVUser ? user : new BobTVUser(user);
        return _user.isUserBlocked(this);
    }

    isUserFollowed(user) {
        for (var index in this.followees) {
            if (this.followees[index] === user.uid) {
                return true;
            }
        }

        return false;
    }
}

/**
 * @param {HitagiChatUser|BobTVUser} user
 */
function isAnonymous(user) {
    return ACCESS_ANONYMOUS === user.member_type;
}

BobTVUser.isAnonymous = isAnonymous;

/**
 * @param {HitagiChatUser|BobTVUser} user
 * @return {boolean}
 */
function isFree(user) {
    return (ACCESS_FREE === user.member_type);
}

BobTVUser.isFree = isFree;

/**
 * @param {HitagiChatUser|BobTVUser} user
 */
function isXXL(user) {
    return (ACCESS_XXL <= user.member_type);
}

BobTVUser.isXXL = isXXL;

/**
 * @param {HitagiChatUser|BobTVUser} user
 * @return {boolean}
 */
function isAdmin(user) {
    return (ACCESS_ADMIN <= user.member_type);
}

BobTVUser.isAdmin = isAdmin;

/**
 * @param {HitagiChatUser|BobTVUser} user
 * @return {boolean}
 */
function isOwner(user) {
    return (ACCESS_OWNER === user.member_type);
}

BobTVUser.isOwner = isOwner;

/**
 * @param {HitagiChatUser|BobTVUser} user
 * @return {boolean}
 */
function isCertified(user) {
    return user.certified;
}

BobTVUser.isCertified = isCertified;

/**
 * @param {HitagiChatUser|BobTVUser} user
 */
function isActive(user) {
    return 1 === user.active;
}

BobTVUser.isActive = isActive;

/**
 * @param {HitagiChatUser|BobTVUser} user
 */
function userExists(user) {
    return typeof user.id !== 'undefined' && user.id > 0;
}

BobTVUser.exists = userExists;

/**
 * @param {BobTVUser} currentUser
 * @param {HitagiChatUser|BobTVUser} userData
 * @return {string}
 */
export function getUserCSSClass(currentUser, userData) {
    var cssClass = "";

    var gender = parseInt(userData.gender);

    if (gender == 1) {
        cssClass += "male";
    } else if (gender == 2) {
        cssClass += "female";
    } else if (gender == 3) {
        cssClass += "couple";
    } else if (gender == 4) {
        cssClass += "transvestite";
    }

    if (BobTVUser.isAnonymous(userData)) {
        cssClass += " anonymous";
    }

    if (!BobTVUser.isCertified(userData)) {
        cssClass += " uncertified";
    }

    var giftRank = parseInt(userData.gift_rank);

    if (giftRank) {
        cssClass += " rank-" + giftRank;
    }

    if (currentUser.isUserBlocked(userData)) {
        cssClass += " blocked";
    }

    return cssClass;
}

/**
 * @param {{avatar_url: string}}|BobTVUser user
 */
export function hasAvatar(user) {
    return user.hasOwnProperty('avatar_url') && user.avatar_url.indexOf('/icons/no_photo') === -1;
}

// auto-complete helper

/**
 * @typedef {object} BobTVUser
 * @property {number} id
 * @property {string} nick
 * @property {number} gender
 * @property {number} age
 * @property {string} country
 * @property {string} region
 * @property {string} about
 * @property {string} email
 * @property {string} avatar_url
 * @property {object} counters
 * @property {number} counters.amount_wallet
 * @property {number} counters.gift_count
 * @property {number} counters.count_black_users
 * @property {number} counters.count_my_messages
 * @property {number} counters.count_my_guest_book
 * @property {number} counters.count_my_following
 */


// WEBPACK FOOTER //
// ./local_modules/bobtvuser/index.js